export default __webpack_public_path__ + "static/media/selectDownArrow.0096c27c.svg";